<div class="dialog-header">
  <app-ice-icon-button
    testId="register-mobilbytte-dialog-back-button"
    [iconName]="IconNames.ice_arrow_left"
    (clicked)="goBack()"
  />
  <span class="bread-crumbs">
    <button data-testid="mobilbytte-pick-new-phone-button" (click)="goBack()">Velg ny telefon /&nbsp;</button>
    <b>Registrer bytte</b>
  </span>
  <app-ice-icon-button
    matDialogClose
    size="32px"
    testId="close-register-mobilbytte-dialog-button"
    [iconName]="IconNames.ice_close"
  />
</div>
<div class="dialog-body">
  @if (!!mobilBytteProductInCart()) {
    <app-phone-card title="Ny telefon" [phone]="mobilBytteProductInCart()" />
  }
  <div class="dialog-body-columns">
    <span class="dialog-left-column">
      <app-mobilephone-header
        title="Gammel telefon"
        [icon]="IconNames.ice_mobilbytte"
        [insuranceName]="insuranceName"
        [insurancePrice]="insurancePrice"
        [mobilePhoneImei]="mobilBytteAgreement.activeImei"
        [mobilePhoneName]="mobilBytteAgreement.phoneModel"
      />
      @if (currentStepIndex === 0) {
        <app-ice-alert type="info" [iconName]="IconNames.ice_info">
          Kunden må sende inn en fysisk telefon ved bytte. Mangler den, kan forsikring benyttes dersom dette er dekket.
        </app-ice-alert>
      }
      @if (!!inquiredControl) {
        <app-control-inquiry [inquiredControl]="inquiredControl" />
      }
      @if (!!inquiredInfoDisclosure) {
        <app-information-disclosure [inquiredInfoDisclosure]="inquiredInfoDisclosure" />
      }
    </span>
    <app-register-mobilbytte-stepper
      class="dialog-right-column"
      [hasInsurance]="!!mobilBytteAgreement.insuranceServiceId"
      (disclosureToFetch)="inquiredInfoDisclosure = $event"
      (infoClicked)="inquiredControl = $event"
      (stepChanged)="currentStepIndex = $event"
      (submitForm)="submit($event)"
    />
  </div>
</div>
